<template>
    <div class="s-loading">

    </div>
</template>
<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from 'axios'
import { getDefaultAuthorizedRoute } from '@/menu/menuService'
export default{
    created() {
        // this.getAllSMS();
        this.chgetCookies();
    },
    methods: {
        normalizeRedirectPath(path){
            if(!path || path == 'null' || path == 'undefined'){
                return '';
            }

            let nextPath = path;
            try {
                const parsedPath = JSON.parse(path);
                if(typeof parsedPath === 'string'){
                    nextPath = parsedPath;
                }
            } catch (_error) {
                nextPath = path;
            }

            if(typeof nextPath !== 'string'){
                return '';
            }

            nextPath = nextPath.trim();
            if(!nextPath || nextPath == '/' || nextPath.toLowerCase() == '/login'){
                return '';
            }

            return nextPath.charAt(0) == '/' ? nextPath : `/${nextPath}`;
        },
        redirectToHome(){
            const preferredPath = this.normalizeRedirectPath(localStorage.getItem('redirectURl'));
            this.$router.push({path: getDefaultAuthorizedRoute(this.$store.getters['state'], preferredPath)});
        },
        redirectToLogin(){
            if(this.$route.name != 'Login'){
                this.$router.push({name: "Login"});
            }
        },
        chgetCookies(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","check");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[all]',"justcheck");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response && response.data ? response.data : {};
                const errorNumber = res.error && typeof res.error.number !== 'undefined'
                    ? parseInt(res.error.number)
                    : 0;

                if(errorNumber == 200 && res.results && res.results.data){
                    this.$store.state.group_id = res.results.data.group_id || 0;
                    this.$store.commit('setEffectivePermissions', res.results.data.effective_permissions || {});
                    this.connected = true;
                    if(this.$route.name == 'Login' || this.$route.name == 'Loading'){
                        if(this.$store.state.group_id != 4){
                            this.redirectToHome();
                        }
                        else{
                            this.$router.push({path: '/vendors/vendor-index/'});
                        }
                    }
                }else{
                    this.connected = false;
                    this.redirectToLogin();
                }
            }).catch(() => {
                this.connected = false;
                this.redirectToLogin();
            })

        },
        getAllSMS(){
            const post = new FormData();
            post.append("type","getSMSTemp");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[all]",'123')
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            )
            .then((res) => {
                // // console.log(res.data);
                this.$store.state.smsTemp = res.data.results.data;
            })
        },
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
    },
}
</script>
<style>
.s-loading{
    position:fixed;
    top:0;
    left:0;
    bottom: 0;
    right: 0;
    background: #00000055;
}
</style>
